/**
 * store the browser to only execute once
 */
var browser;

/**
 * get the browser and it's version
 *   Taken and modified from: http://www.browser-update.org/
 *   Look for "by SPiNNWERK" comments for more info
 */
export default function() {
    // return cached browser if available
    if (browser !== undefined) { return browser; }

    var n, v,  app = "", ua = navigator.userAgent || navigator.vendor || window.opera, donotnotify = false;
    var names={i:'Internet Explorer',f:'Firefox',o:'Opera',s:'Apple Safari',n:'Netscape Navigator', c:"Chrome", a:"Android", x:"Other", fb:"Facebook"};
    // modified by SPiNNWERK:
    //   removed: android|phone|iPad|iPhone|iPod
    if (/bot|googlebot|facebook|slurp|wii|silk|blackberry|maxthon|maxton|mediapartners|dolfin|dolphin|adsbot|silk|bingbot|google web preview|like firefox|chromeframe|seamonkey|opera mini|min|meego|netfront|moblin|maemo|arora|camino|flot|k-meleon|fennec|kazehakase|galeon|epiphany|konqueror|rekonq|symbian|webos|coolnovo|blackberry|bb10|RIM|PlayBook|PaleMoon|QupZilla/i.test(ua)) n="x";
    else if (/Trident.*rv:(\d+\.\d+)/i.test(ua)) n="i";
    else if (/Trident.(\d+\.\d+)/i.test(ua)) n="io";
    else if (/MSIE.(\d+\.\d+)/i.test(ua)) n="i";
    else if (/Edge.(\d+\.\d+)/i.test(ua)) n="i";
    else if (/OPR.(\d+\.\d+)/i.test(ua)) n="o";
    else if (/Chrome.(\d+\.\d+)/i.test(ua)) n="c";
    else if (/Firefox.(\d+\.\d+)/i.test(ua)) n="f";
    // added by SPiNNWERK:
    //   check for Android versions
    else if (/Android.(\d+\.?\d+)/i.test(ua)) n="a";
    else if (/Version.(\d+.\d+).{0,10}Safari/i.test(ua)) n="s";
    else if (/Safari.(\d+)/i.test(ua)) n="so";
    else if (/Opera.*Version.(\d+\.\d+)/i.test(ua)) n="o";
    else if (/Opera.(\d+\.?\d+)/i.test(ua)) n="o";
    else if (/Netscape.(\d+)/i.test(ua)) n="n";
    else return {n:"x",v:0,t:names[n]};

    v = parseFloat(RegExp.$1);

    // do not notify very old systems since their is no up-to-date browser available
    if (/windows.nt.5.0|windows.nt.4.0|windows.98|os x 10.4|os x 10.5|os x 10.3|os x 10.2/.test(ua)){
        donotnotify="oldOS";
    }

    // do not notify firefox ESR
    if (n=="f" && (Math.round(v)==24 || Math.round(v)==31)) {
        donotnotify="ESR";
    }
    // do not notify opera 12 on linux since it is the latest version
    if (/linux|x11|unix|bsd/.test(ua) && n=="o" && v>12) {
        donotnotify="Opera12Linux";
    }

    if (n=="x") {
        return {n:"x",v:v||0,t:names[n],donotnotify:donotnotify};
    }

    // added by SPiNNWERK:
    //   expect we have an Safari iOS device (iPhone, iPod, iPad) parse the right version number
    if (n=="so") {
        if(/(iPad|iPhone|iPod|iPod touch);.*CPU.*OS (\d+\_?\d+)/i.test(ua)){
            v= parseFloat(RegExp.$2.replace('_', '.'));
            n="s";
        }
    }

    if (n=="i" && v==7 && window.XDomainRequest) {
        v=8;
    }

    if (n=="io") {
        n="i";
        if (v>6) v=11;
        else if (v>5) v=10;
        else if (v>4) v=9;
        else if (v>3.1) v=8;
        else if (v>3) v=7;
        else v=9;
    }

    // added by SPiNNWERK:
    //   check if the user is in an "in app browser"
    //
    // check for facebook in app browser
    // http://stackoverflow.com/questions/31569518/how-to-detect-facebook-in-app-browser#32348687
    if (ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1) app="fb";

    browser = {n:n,v:v,app:app,t:names[n]+" "+v,donotnotify:donotnotify};

    return browser;
}
